<template>
  <div>
    <div :class="`d-flex floorplan-box ${isSelect ? 'select' : isEdit ? '' : 'n-select'
      }`">
      <v-card elevation="0" class="me-1 area-header" v-if="isEdit">
        <v-list>
          <v-list-item-group v-model="selectToolBar" color="primary">
            <v-list-item @click="
              selectToolBar == 0
                ? (selectToolBar = null)
                : (selectToolBar = 0)
              ">
              <v-list-item-content class="text-center">
                <v-list-item-title>
                  <div>
                    <v-icon>mdi-floor-plan</v-icon>
                  </div>
                  <div style="width: 50px">
                    <small>{{ $t('area.space') }}</small>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="project && project.layoutType == 2" @click="
              selectToolBar == 1
                ? (selectToolBar = null)
                : (selectToolBar = 1)
              ">
              <v-list-item-content class="text-center">
                <v-list-item-title>
                  <div>
                    <v-icon>mdi-image-area</v-icon>
                  </div>
                  <div style="width: 50px">
                    <small>{{ $t('image') }}</small>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
      <v-card elevation="0" class="me-1 area-list" width="400" v-if="isEdit && (selectToolBar || selectToolBar == 0)">
        <template v-if="selectToolBar == 0">
          <v-card-title class="px-2 py-2">
            {{ $t('area.all_stall') }}
            <v-spacer />
            <template v-if="!isSortArea">
              <v-btn class="mx-1" :disabled="isLoading" color="info" @click="isAddAreaDialog = true">
                <v-icon left>mdi-plus</v-icon>{{ $t('area.add_stall') }}
              </v-btn>
              <v-menu bottom offset-y left :disabled="isLoading || isChangeOrder">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" :disabled="isLoading || isChangeOrder">
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <div class="py-2 px-3" style="width: 270px;">
                    <b>{{ $t('area.setting_area') }}</b>
                    <hr class="mt-2" />
                  </div>
                  <v-list-item @click="onSortArea()">
                    <v-list-item-title>
                      <v-icon left>mdi-sort</v-icon>{{ $t('area.sort_stall') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="error--text" @click="isResetPlanConfirmDialog = true">
                    <v-list-item-title>
                      <v-icon left color="error">mdi-cog-refresh-outline</v-icon>{{ $t('area.reset_all_setting_area') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-else>
              <v-btn class="mx-1" :disabled="isLoading" color="success" @click="isSortConfirmDialog = true">
                {{ $t('save_all') }}
              </v-btn>
              <v-btn class="mx-1" :disabled="isLoading" color="error" @click="cancelSortArea()">
                {{ $t('cancel') }}
              </v-btn>
            </template>
          </v-card-title>
          <v-card-text class="area-list-card-text" style="padding-bottom: 0">
            <v-text-field :label="$t('area.search_stall_only')" v-model="searchArea" solo dense flat
              background-color="grey lighten-4" hide-details></v-text-field>
            <v-data-table
              class="area-list-card-text-table"
              item-class="area-list-card-text-table-in"
              height="100%"
              :key="`areas-setting-data-${renderKey}`"
              :headers="areaTable.headers"
              fixed-header
              :items="areaTable.items"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              hide-default-footer
              disable-pagination
              :search="searchArea"
              :loading="isChangeOrder"
              :no-data-text="$t('noinfo')"
              :no-results-text="$t('no_matching_records_found')">
              <template v-slot:item.order="{ index }">{{ index + 1 }}</template>
              <template v-slot:item.size="{ item }">{{
                item.size | currency
              }}</template>
              <template v-slot:item.action="{ item }">
                <v-btn v-if="areaPlans.find((d) => d.objectId == item.objectId)" color="info" @click="focusPlan(item)"
                  :disabled="isLoading || isChangeOrder">
                  <!-- <v-icon left>mdi-crosshairs-gps</v-icon> -->
                  {{ $t('area.go_to_object') }}
                </v-btn>
                <v-btn v-else color="primary" @click="createPlan(item)" :disabled="isLoading || isChangeOrder">
                  <!-- <v-icon left>mdi-crosshairs-gps</v-icon> -->
                  {{ $t('area.add_object') }}
                </v-btn>
              </template>
              <template v-slot:item.actiontwo="{ item }">
                <v-menu absolute offset-y :disabled="isLoading || isChangeOrder">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :disabled="isLoading || isChangeOrder">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editArea(item)">
                      <v-list-item-title>
                        <v-icon left>mdi-pencil</v-icon>{{ $t('area.edit_stall') }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="editGeoPoint(item)">
                      <v-list-item-title>
                        <v-icon left>mdi-map-marker-outline</v-icon>{{ $t('area.edit_stall_location') }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-tooltip bottom v-if="checkBookingAndContract(item).isCannotRemove" color="#66BB6AE3">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-list-item disabled color="gray">
                            <v-list-item-title>
                              <v-icon left disabled>mdi-trash-can-outline</v-icon>{{ $t('area.delete_stall') }}
                            </v-list-item-title>
                          </v-list-item>
                        </div>
                      </template>
                      <div v-if="checkBookingAndContract(item).isCannotRemove">
                        {{ $t('area.cannot_delete_stall_because') }} :
                      </div>
                      <div class="pl-2" v-if="checkBookingAndContract(item).hasBooking">
                        - {{ $t('booking.already_have_booking_stall') }}
                        {{
                          checkBookingAndContract(item).hasBooking
                        }}
                        {{ $t('area.list_in_this_stall') }}
                      </div>
                      <div class="pl-2" v-if="checkBookingAndContract(item).hasAreaBooking">
                        - {{ $t('area.renter_in_this_stall') }}
                      </div>
                      <div class="pl-2" v-if="checkBookingAndContract(item).hasContract">
                        - {{ $t('contract.has_contract_in_this_stall') }}
                      </div>
                    </v-tooltip>
                    <v-list-item v-else @click="dialogRemoveArea(item)">
                      <v-list-item-title>
                        <v-icon left>mdi-trash-can-outline</v-icon>{{ $t('area.delete_stall') }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </template>
        <template v-if="selectToolBar == 1">
          <v-card-title class="px-2 py-2">
            {{ $t('image') }}
            <v-spacer />
            <v-btn :disabled="isLoading" color="primary" @click="isUploadImageDialog = true">
              <v-icon left>mdi-cloud-upload-outline</v-icon>{{ $t('upload.upload_image') }}
            </v-btn>
          </v-card-title>
          <v-card-text class="px-1 scroll">
            <v-row v-masonry no-gutters>
              <v-col class="px-1 py-1" cols="6" v-for="image in hashImage" :key="image">
                <v-card @click="createImage(image)">
                  <v-img @load="$redrawVueMasonry()" :src="image" />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-card>
      <div :style="isEdit && (selectToolBar || selectToolBar == 0) ? 'width: calc(100% - 492px)' : 'width: 100%'">
        <div :class="`floorplan ${isSelect ? 'select' : isEdit ? '' : 'n-select'}`"
          :style="height ? `min-height: ${height}px` : ''" ref="viewbox">
          <div class="zoom" :style="{
            top: mode === 'occrate' ? '18px' : '',
            left: searchPosition === 'left' ? '10px' : '',
            right: searchPosition === 'right' ? '10px' : ''
          }">
            <v-btn icon @click="zoom('out')" small>
              <v-icon>mdi-magnify-minus</v-icon>
            </v-btn>
            <span style="width: 50px" class="text-center">{{ Math.round(viewboxScale * 100 * 10) / 10 }}%</span>
            <v-btn icon @click="zoom('in')" small>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
            <template v-if="isEdit">
              <v-btn color="primary" @click="isSavePlanConfirmDialog = true" class="ms-2" :disabled="isLoading == true"
                elevation="1">{{ $t('area.save_market_plan') }}</v-btn>
            </template>
            <template v-else>
              <template v-if="mode != 'occrate'">
                <v-text-field v-model="search" class="mx-1" outlined dense :placeholder="$t('area.search_stall_only')"
                  hide-details clearable style="width: 200px" v-if="!isHideSearch">
                  <template v-slot:append>
                    <span v-if="search || selectProduct" style="
                        font-size: 13px;
                        color: gray;
                        font-weight: 200;
                        padding-top: 5px;
                        width: 65px;
                        text-align: right;
                      ">
                      {{ $t('area.result', { count: areaPlanResultCount }) }}
                    </span>
                  </template>
                </v-text-field>
                <v-autocomplete v-model="selectProduct" :items="[
                  { text: $t('all'), value: '' },
                  ...productCategoryOptions,
                  ...productOptions,
                ]" item-text="text" :placeholder="$t('product.title')" return-object class="ms-1" outlined dense
                  hide-details clearable style="width: 150px"></v-autocomplete>
                <v-autocomplete v-model="selectStatus" :items="[{ text: $t('all'), value: '' }, ...statusOption]"
                  item-text="text" :placeholder="$t('status')" return-object class="ms-1" outlined dense
                  hide-details clearable style="width: 150px"></v-autocomplete>
              </template>
              <template v-else>
                <template v-if="project && project.layoutType == 2">
                  <v-autocomplete v-model="localSelectMarketArea" :items="marketData" item-text="name"
                    item-value="objectId" :placeholder="$t('market.select_market')" class="ms-1" outlined dense
                    hide-details style="width: 200px;" @change="changeSelectMarket"></v-autocomplete>
                </template>
                <template v-else>
                  <v-autocomplete v-model="localSelectMarketArea"
                    :items="[{ name: $t('all'), objectId: '' }, ...marketData]" item-text="name" item-value="objectId"
                    :placeholder="$t('market.select_market')" class="ms-1" outlined dense hide-details
                    style="width: 200px;" @change="changeSelectMarket"></v-autocomplete>
                </template>

                <v-select v-model="areaOccrateType" :items="areaOccrateOption" @change="initAreaPlan()" item-text="text"
                  :placeholder="$t('project.total_income')" class="ms-1" outlined dense hide-details
                  style="width: 150px;" :no-data-text="$t('noinfo')">
                </v-select>
              </template>
            </template>
          </div>

          <div class="abs-header" v-if="mode == 'occrate'">
            <div class="sub-title">{{ $t('project.project_plan') }}</div>
            <div class="txt-title">{{ $t('market.your_market_plan') }}</div>
          </div>

          <v-row v-resize="onResize" :class="`px-0 mx-0 my-0 py-0`">
            <div :id="tooltipStallId" class="tooltip-stall"
              :style="`${mode == 'occrate' ? 'background: rgba(0, 0, 0, 0.7);' : ''}`"
              v-show="(!isEdit || isSelect) && tooltipVisible">
              <div class="tooltip-stall-header">
                <span>{{ $t('area.space') }} {{ tooltipData.stallName }}</span> ({{
                  tooltipData.size
                }}
                {{ $t('square_meter') }})
              </div>
              <div v-if="mode != 'occrate'" class="tooltip-stall-body">
                <div v-if="tooltipData.businessName != ''" class="tooltip-detail">
                  <span>{{ $t('area.shop_name') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.businessName
                  }}</span>
                </div>
                <div v-if="tooltipData.fullName != ''" class="tooltip-detail">
                  <span>{{ $t('contract.contractor_name') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.fullName
                  }}</span>
                </div>
                <div v-if="tooltipData.productList != ''" class="tooltip-detail">
                  <span>{{ $t('product.title') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.productList
                  }}</span>
                </div>
                <div class="tooltip-detail">
                  <span>{{ $t('status') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.statusName
                  }}</span>
                </div>
              </div>
              <div v-else class="tooltip-stall-body">
                <div v-if="tooltipData.rentalRate != ''" class="tooltip-detail">
                  <span>{{ $t('area.rental_rate') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.rentalRate
                  }}</span>
                </div>
                <div v-if="tooltipData.income != ''" class="tooltip-detail">
                  <span>{{ $t('income.title') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.income
                  }}</span>
                </div>
                <div v-if="tooltipData.rankRentalRate != ''" class="tooltip-detail">
                  <span>{{ project && project.layoutType == 1 ? $t('area.ranking_rental_rate_in_zone') :
                    $t('area.ranking_rental_rate_in_market') }} </span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.rankRentalRate
                  }}</span>
                </div>
                <div v-if="tooltipData.rankIncomeMarket != ''" class="tooltip-detail">
                  <span>{{ project && project.layoutType == 1 ? $t('area.ranking_income_in_zone') :
                    $t('area.ranking_income_in_market') }}</span>
                  <span class="tooltip-detail-result">{{
                    tooltipData.rankIncomeMarket
                  }}</span>
                </div>
              </div>
              <div class="tooltip-stall-footer">
                <div v-if="getCounting(tooltipData.id, 'dailyBooking') > 0" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/booking-stall-icon.svg')" width="15px"
                      height="15px">
                    <span>{{ $t('booking.daily_booking') }}</span>
                  </div>
                  <span class="tooltip-detail-result">{{
                    getCounting(tooltipData.id, "dailyBooking")
                  }}
                    {{ $t('booking.booking') }}</span>
                </div>
                <div v-if="getCounting(tooltipData.id, 'monthlyBooking') > 0" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/booking-stall-icon.svg')" width="15px"
                      height="15px">
                    <span>{{ $t('booking.monthly_booking') }}</span>
                  </div>
                  <span class="tooltip-detail-result">{{
                    getCounting(tooltipData.id, "monthlyBooking")
                  }}
                    {{ $t('booking.booking') }}</span>
                </div>
                <div v-if="getCounting(tooltipData.id, 'areaInterest') > 0" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/areaInterest-icon.svg')" width="15px"
                      height="15px">
                    <span>{{ $t('area.area_interest_amount') }}</span>
                  </div>
                  <span class="tooltip-detail-result">{{ getCounting(tooltipData.id, "areaInterest") }} {{ $t('people')
                  }}</span>
                </div>

                <div v-if="getDueDate(tooltipData.contractId)" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/overdue.svg')" width="15px" height="15px">
                    <span>{{ $t('bill.overdue_bill') }}</span>
                  </div>
                  <span class="tooltip-detail-result text-red">
                    {{ $t('payment.overdue_payment_day', { time: getDueDate(tooltipData.contractId) }) }}
                  </span>
                </div>

                <div v-if="getDueDate(tooltipData.bookingId)" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/overdue.svg')" width="15px" height="15px">
                    <span>{{ $t('bill.overdue_bill') }}</span>
                  </div>
                  <span class="tooltip-detail-result text-red">
                    {{ $t('payment.overdue_payment_day', { time: getDueDate(tooltipData.bookingId) }) }}
                  </span>
                </div>

                <div v-if="tooltipData.isContractExpired" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/contract-expire-2.svg')" width="15px"
                      height="15px">
                    <span>{{ $t('contract.contract_expired') }}</span>
                  </div>
                </div>
                <div v-if="tooltipData.isAlmostExpired" class="tooltip-detail">
                  <div class="d-flex align-center">
                    <img class="me-1" :src="require('@/assets/images/contract-expire-1.svg')" width="15px"
                      height="15px">
                    <span>{{ $t('contract.contract_will_expired') }}</span>
                  </div>
                  <span class="tooltip-detail-result">
                    <div>{{ tooltipData.dateExprired == 0 ? $t('contract.contract_expired_today') :
                      $t('contract.contract_left') + tooltipData.dateExprired + $t('day') }} </div>
                  </span>
                </div>
                <template v-if="tooltipData.meterLessThanMeter && tooltipData.meterLessThanMeter.length > 0">
                  <div v-for="(mt, inx) in tooltipData.meterLessThanMeter" class="tooltip-detail">
                    <div v-if="inx == 0" class="d-flex align-center">
                      <img class="me-1" :src="require('@/assets/images/meterprepaid.svg')" width="15px" height="15px">
                      <span><strong>{{ $t('meter.title') }}</strong> {{ $t('meter.your_meter_is_less_than_minimum_unit')
                      }} <span class="error--text"><strong>{{ mt.lowUnit }} {{ $t('meter.unit_title')
                        }}</strong></span></span>
                    </div>
                  </div>
                </template>
              </div>
              <div v-if="tooltipData.isPaymentApprove" class="tooltip-stall-footer-sub">
                <div class="d-flex align-center justify-center">
                  <img class="me-1" :src="require('@/assets/images/money-approve.svg')" width="15px" height="15px">
                  <span>{{ $t('payment.payment_notification') }}</span>
                </div>
              </div>
            </div>
            <konva-stage :config="stageConfig" ref="stage" @mousedown="isEdit && handleStageMouseDown($event)"
              @touchstart="selectedTooltipName = ''" @wheel="onWheel" @touchend="onEndPinch" @touchmove="onPinch">
              <konva-layer ref="layer">
                <konva-group v-for="obj in orderAreaPlanImage" :key="`order_area_plan_image_${obj.objectId}`"
                  @transformend="isEdit && handleTransformEnd($event)" @dragend="isEdit && handleTransformEnd($event)"
                  :config="{
                    rotation: obj.layout.rotation || 0,
                    x: obj.layout.x,
                    y: obj.layout.y,
                    name: obj.objectId,
                    draggable: isEdit && selectToolBar == 1 ? true : false,
                    scaleX: obj.layout.scaleX || 1,
                    scaleY: obj.layout.scaleY || 1,
                  }">
                  <konva-image :config="{
                    width: obj.layout.width,
                    height: obj.layout.height,
                    image: obj.layout.image,
                    name: obj.objectId,
                  }" />
                </konva-group>
                <konva-group v-for="obj in areaPlans.filter((d) => d.type == 'area' && d.layout)"
                  :key="`area_${obj.objectId}`" @transformend="isEdit && handleTransformEnd($event)"
                  @dragend="isEdit && handleTransformEnd($event)" @click="!isEdit && onClickPlan(obj)" :config="{
                    rotation: obj.layout.rotation || 0,
                    x: obj.layout.x,
                    y: obj.layout.y,
                    name: obj.objectId,
                    draggable: isEdit && selectToolBar == 0 ? true : false,
                    visible: !obj.isBlur,
                    scaleX: obj.layout.scaleX || 1,
                    scaleY: obj.layout.scaleY || 1,
                  }">
                  <component class="relative" v-if="obj.type == 'area'" :is="obj.layout.shapeType"
                    @mouseover="(e) => handleMouseOver(e, obj)" @mouseout="handleMouseOut"
                    @touchstart="handleTouchstart" @touchend="handleTouchend" :config="{
                      id: obj.objectId,
                      name: obj.objectId,
                      width: obj.layout.width || 100,
                      height: obj.layout.height || 100,
                      stroke: setColorStroke(obj),
                      strokeWidth: 2,
                      strokeScaleEnabled: false,
                      fill: obj.style.fill,
                    }" />
                  <!-- -------------------konva-rect------------------ -->
                  <konva-group v-if="obj.layout.shapeType == 'konva-rect'" @mouseover="(e) => handleMouseOver(e, obj)"
                    @mouseout="handleMouseOut" @touchstart="handleTouchstart" @touchend="handleTouchend">
                    <konva-text :config="{
                      name: obj.objectId,
                      text: obj.name,
                      fontSize: 15,
                      fontFamily: 'Prompt',
                      fill: obj.style.textColor,
                      align: 'center',
                      x: 0,
                      y: 23,
                      width: obj.layout.width,
                      wrap: 'none',
                      ellipsis: true
                    }" />
                    <konva-text v-if="!isSelect" :config="{
                      name: obj.objectId,
                      text: obj.businessName,
                      fontSize: 13,
                      fontFamily: 'Prompt',
                      fill: obj.style.textColor,
                      align: 'center',
                      x: 0,
                      y: 42,
                      width: obj.layout.width,
                      wrap: 'none',
                      ellipsis: true
                    }" />
                    <konva-text v-if="isSelect" :config="{
                      name: obj.objectId,
                      text: obj.isCanSelect ? $t('empty') : $t('not_empty'),
                      fontSize: 16,
                      fontFamily: 'Prompt',
                      fill: obj.style.textColor,
                      align: 'center',
                      x: 0,
                      y: 55,
                      width: obj.layout.width,
                    }" />
                  </konva-group>
                  <!-- -------------------konva-circle------------------ -->
                  <konva-group v-if="obj.layout.shapeType == 'konva-circle'" @mouseover="(e) => handleMouseOver(e, obj)"
                    @mouseout="handleMouseOut" @touchstart="handleTouchstart" @touchend="handleTouchend">
                    <konva-text :config="{
                      name: obj.objectId,
                      text: obj.name,
                      fontSize: 15,
                      fontFamily: 'Prompt',
                      fill: obj.style.textColor,
                      x: (obj.layout.width / 2) * -1,
                      y: (obj.layout.height / 2) * -1 + 27,
                      align: 'center',
                      width: obj.layout.width,
                      wrap: 'none',
                      ellipsis: true,
                    }" />
                    <konva-text v-if="!isSelect" :config="{
                      name: obj.objectId,
                      text: obj.businessName,
                      fontSize: 13,
                      fontFamily: 'Prompt',
                      fill: obj.style.textColor,
                      x: (obj.layout.width / 2) * -1,
                      y: (obj.layout.height / 2) * -1 + 44,
                      align: 'center',
                      width: obj.layout.width,
                      wrap: 'none',
                      ellipsis: true,
                    }" />
                    <konva-text v-if="isSelect" :config="{
                      name: obj.objectId,
                      text: obj.isCanSelect ? $t('empty') : $t('not_empty'),
                      fontSize: 16,
                      fontFamily: 'Prompt',
                      fill: obj.style.textColor,
                      x: (obj.layout.width / 2) * -1,
                      y: (obj.layout.height / 2) * -1 + 60,
                      align: 'center',
                      width: obj.layout.width,
                    }" />
                  </konva-group>
                </konva-group>

                <template v-if="!isEdit && !isSelect">
                  <!-- image icon rect -->
                  <konva-group
                    v-for="(obj, index) in areaPlans.filter(d => d.type == 'area' && d.layout.shapeType === 'konva-rect')"
                    :key="`iconRect${index}`" :config="{
                      name: obj.objectId,
                      rotation: obj.layout.rotation,
                      x: obj.layout.x,
                      y: obj.layout.y,
                      visible: !obj.isBlur,
                    }">
                    <template v-if="mode != 'occrate'">
                      <konva-image v-if="showImageBooking(obj.objectId)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'booking'),
                        width: 25,
                        height: 25,
                        image: imageBooking,
                      }" />
                      <konva-image v-if="showImageAreaInterest(obj.objectId)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'areaInterest'),
                        width: 25,
                        height: 25,
                        image: imageAreaInterest,
                      }" />
                      <konva-image v-if="showImageSlip(obj)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'slip'),
                        width: 25,
                        height: 25,
                        image: imageSlip,
                      }" />
                      <konva-image v-if="showImageDueDate(obj)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'dueDate'),
                        width: 25,
                        height: 25,
                        image: imageDueDate,
                      }" />

                      <konva-image v-if="showImageAlmostExprired(obj)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'almostExprired'),
                        width: 25,
                        height: 25,
                        image: imageAlmostExprired,
                      }" />

                      <konva-image v-if="showImageContractExprired(obj)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'contractExprired'),
                        width: 25,
                        height: 25,
                        image: imageExpried,
                      }" />

                      <konva-image v-if="showImageLessThanMeter(obj)" :config="{
                        name: obj.objectId,
                        x: obj.layout.width * obj.layout.scaleX - 13,
                        y: setImageRectPositionY(obj, 'lessThanMeter'),
                        width: 25,
                        height: 25,
                        image: imageLessThanMeter,
                      }" />
                    </template>
                  </konva-group>
                  <!-- image icon circle -->
                  <konva-group
                    v-for="(obj, index) in areaPlans.filter(d => d.type == 'area' && d.layout.shapeType === 'konva-circle')"
                    :key="`iconCircle${index}`" :config="{
                      name: obj.objectId,
                      rotation: 0,
                      x: obj.layout.x,
                      y: obj.layout.y,
                      visible: !obj.isBlur,
                    }">
                    <template v-if="mode != 'occrate'">
                      <konva-image v-if="showImageBooking(obj.objectId)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'booking'),
                        y: setImageCirclePositionY(obj, 'booking'),
                        width: 25,
                        height: 25,
                        image: imageBooking,
                      }" />
                      <konva-image v-if="showImageAreaInterest(obj.objectId)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'areaInterest'),
                        y: setImageCirclePositionY(obj, 'areaInterest'),
                        width: 25,
                        height: 25,
                        image: imageAreaInterest,
                      }" />
                      <konva-image v-if="showImageSlip(obj)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'slip'),
                        y: setImageCirclePositionY(obj, 'slip'),
                        width: 25,
                        height: 25,
                        image: imageSlip,
                      }" />
                      <konva-image v-if="showImageDueDate(obj)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'dueDate'),
                        y: setImageCirclePositionY(obj, 'dueDate'),
                        width: 25,
                        height: 25,
                        image: imageDueDate,
                      }" />

                      <konva-image v-if="showImageAlmostExprired(obj)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'almostExprired'),
                        y: setImageCirclePositionY(obj, 'almostExprired'),
                        width: 25,
                        height: 25,
                        image: imageAlmostExprired,
                      }" />
                      <konva-image v-if="showImageContractExprired(obj)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'contractExprired'),
                        y: setImageCirclePositionY(obj, 'contractExprired'),
                        width: 25,
                        height: 25,
                        image: imageExpried,
                      }" />
                      <konva-image v-if="showImageLessThanMeter(obj)" :config="{
                        name: obj.objectId,
                        x: setImageCirclePositionX(obj, 'lessThanMeter'),
                        y: setImageCirclePositionY(obj, 'lessThanMeter'),
                        width: 25,
                        height: 25,
                        image: imageLessThanMeter,
                      }" />
                    </template>
                  </konva-group>
                </template>
                <konva-transformer ref="transformer" @transformend="isEdit && updateTransformer" />
              </konva-layer>
            </konva-stage>
          </v-row>
          <div class="progress-plan-area" v-if="mode == 'occrate'">
            <div v-if="areaOccrateType == 'rentalRate'">{{ $t('area.rental_rate') }} {{
              $helper.toCurrency(progressArea.min)
            }}%</div>
            <div v-else-if="areaOccrateType == 'totalIncome'">{{ $t('income.do_total_income') }} {{ progressArea.min |
              currencySuffixSign }}</div>
            <div v-else-if="areaOccrateType == 'incomeMetres'">{{ $t('income.do_income_per_square_meter') }} {{
              progressArea.min | currencySuffixSign }}</div>
            <div class="progress-color">
              <div class="color"></div>
            </div>
            <div>{{ $helper.toCurrency(progressArea.max) }}<span v-if="areaOccrateType == 'rentalRate'">%</span><span
                v-else>{{ $helper.currencySign() }}</span></div>
          </div>
          <div class="action" v-if="isEdit && selectPlan">
            <div class="d-flex align-center px-3">
              <template v-if="selectPlan.type == 'area'">
                <div class="font-weight-bold border-r d-flex align-center" style="width: 150px; height: 44px;">
                  <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ $t('area.space') }} {{ selectPlan.name }}
                  </div>
                </div>
                <div style="width: 230px;" class="text-center border-r">
                  {{ $t('format') }} :
                  <v-btn icon large @click="editShapeType('konva-rect')" color="#dadbdd">
                    <v-icon large>mdi-rectangle</v-icon>
                  </v-btn>
                  <v-btn icon large @click="editShapeType('konva-circle')" color="#dadbdd">
                    <v-icon large>mdi-circle</v-icon>
                  </v-btn>
                </div>
              </template>
              <div style="width: 100px;">
                <v-btn :disabled="isLoading" color="error" class="ms-2" @click="selectPlan.type == 'area' ? removePlan() : removeImage()" elevation="1">{{$t('area.delete_object') }}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="colorDialog" persistent max-width="350">
      <v-card>
        <v-card-title>{{ $t('select_color') }}</v-card-title>
        <v-card-text class="py-5">
          <v-color-picker v-model="color" flat mode="hexa"></v-color-picker>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="error" @click="colorDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn elevation="0" color="success" @click="colorDialog = false">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-dialog v-model="isAreaDetailDialog" max-width="500">
      <v-card>
        <v-card-text v-if="tempAreaPlan">
          <v-btn v-if="tempAreaPlan.contract" color="success" block large class="mt-4" @click="isContractDialog = true">
            <v-icon class="me-2">mdi-file-document</v-icon>{{ $t('market.market_plan_detail') }}
          </v-btn>
          <v-btn v-if="tempAreaPlan.areaInterest" color="success" block large class="mt-4"
            @click="isInterestDialog = true">
            <v-icon class="me-2">mdi-calendar-multiselect</v-icon>{{ $t('booking.booking_data_detail') }}
          </v-btn>
          <v-btn v-if="!tempAreaPlan.isOccupied" color="success" block large class="mt-4"
            @click="isSelectCustomerDialog = true">
            <v-icon class="me-2">mdi-account-arrow-left</v-icon>{{ $t('customer.add_customer') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <contract-detail-dialog v-if="tempAreaPlan" :contractId="tempAreaPlan.contract ? tempAreaPlan.contract.objectId : null
      " :areaObject="tempAreaPlan.area" v-model="isContractDialog" :show-area="false" :marketId="market.objectId"
      :projectId="market.project.objectId" @reloadContract="reloadContract"></contract-detail-dialog>
    <UploadImage v-model="isUploadImageDialog" @onSuccess="onUploadImageSuccess" />
    <AreaManageDialog v-model="isAreaManageDialog" :market="market" :area="tempArea" @onSuccess="initAreaPlan()"
      type="edit" />
    <AreaManageDialog v-model="isAddAreaDialog" :market="market" type="add" />
    <AreaGeoDialog v-model="isAreaGeoDialog" :market="market" :area="tempArea" @onSuccess="initAreaPlan()"
      type="edit" />
    <ConfirmDialog v-model="isRemoveAreaDialog" v-if="tempArea" :title="$t('area.delete_sale_stall')"
      :text="$t('validate.want_delete_sale_stall', { name: tempArea.name })" :disabled="isSaveing"
      @onOk="removeArea()" />
    <InterestDialog v-if="tempAreaPlan && tempAreaPlan.areaInterest" v-model="isInterestDialog"
      :objectId="tempAreaPlan.areaInterest.objectId" :isUpdate="true" @onSuccess="loadData()" />
    <SelectCustomer v-model="isSelectCustomerDialog" @select="createContractDialog" :isMainLoading="isLoading" />
    <FormContract v-if="tempAreaPlan && tempAreaPlan.area" event="create" v-model="isCreateContractDialog"
      :areaObject="tempAreaPlan.area" @onCreateSuccess="loadData()" />
    <LoadingPercentDialog v-model="isLoadingPercentDialog" :final="loadingFinal" :initial="loadingInitial" />
    <ConfirmDialog v-model="isSavePlanConfirmDialog" :title="$t('area.save_market_plan')"
      :text="$t('validate.you_want_to_save_market_plan')" :disabled="isSaveing" @onOk="saveObject()" />
    <ConfirmDialog v-model="isResetPlanConfirmDialog" :title="$t('area.reset_all_setting_area')"
      :text="$t('validate.you_want_to_reset_market_plan')" :disabled="isSaveing" @onOk="resetPlan()" type="error" />
    <ConfirmDialog v-model="isSortConfirmDialog" :title="$t('area.save_sort_stall')"
      :text="$t('validate.you_want_to_save_sort_stall')" :disabled="isSaveing" @onOk="saveAreaOrder()" />
  </div>
</template>

<script>
import Sortable from "sortablejs";
import AddArea from "./AddArea";
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import ContractDetailDialog from "./ContractDetailDialog.vue";
import UploadImage from "@/components/UploadImage.component.vue";
import AreaManageDialog from "@/components/AreaManageDialog.component.vue";
import AreaGeoDialog from "@/components/AreaGeoDialog.vue";
import ConfirmDialog from "@/components/ConfirmDialog.component.vue";
import InterestDialog from "@/components/InterestDialog.vue";
import SelectCustomer from "@/components/SelectCustomer.vue";
import FormContract from "./FormContract.vue";
import LoadingPercentDialog from "@/components/LoadingPercentDialog.component.vue";
import { Customer } from "../classes";
import Helper from "../plugins/Helper/Helper";
export default {
  props: {
    isEdit: Boolean,
    height: Number,
    isSelect: Boolean,
    selectAreas: Array,
    vacancyAreas: Array,
    selectLimit: Number,
    areaBookings: Array,
    projectId: String,
    singleSelect: Boolean,
    isHideSearch: Boolean,
    searchText: String,
    areaBookingSummaryByMarket: Object,
    summaryData: Object,
    tooltipStallId: String,
    isBooking: Boolean,
    searchPosition: String,
    invoiceDueDateSummary: Object,
    mode: String,
    areaOccrateData: Object,
    marketId: String,
    marketData: Array,
    selectMarketArea: String,
    isLoadingSummary: Boolean,
  },
  components: {
    AddArea,
    ContractDetailDialog,
    UploadImage,
    AreaManageDialog,
    AreaGeoDialog,
    ConfirmDialog,
    InterestDialog,
    SelectCustomer,
    FormContract,
    LoadingPercentDialog,
  },
  computed: {
    ...mapGetters({
      getMarketId: "markets/getMarketId",
      // market: "markets/getMarket",
      areas: "area/getAreas",
    }),
    areaTable() {
      return {
        sortBy: "order",
        sortDesc: false,
        headers: [
          {
            text: this.$t('rank'),
            value: "order",
            align: "center",
            width: "50px"
          },
          {
            text: this.$t('area.area_name'),
            value: "name",
            align: "center"
          },
          {
            text: this.$t('area.area_size_square_meter'),
            value: "size",
            align: "center",
            width: "65px",
            sortable: false
          },
          {
            text: "",
            value: "action",
            align: "center",
            sortable: false,
            width: "110px",
            padding: 0
          },
          {
            text: "",
            value: "actiontwo",
            align: "center",
            width: "37px",
            sortable: false
          }
        ],
        items: this.areas
      };
    },
    orderAreaPlanImage() {
      return this.areaPlans
        .filter(d => d.type == "market" && d.layout)
        .sort(function (a, b) {
          if (parseInt(a.objectId) < parseInt(b.objectId)) {
            // objectId is time stamp
            return -1;
          } else {
            return 1;
          }
        });
    },
    areaPlanResultCount() {
      if (this.areaPlans) {
        return this.areaPlans.filter(d => !d.isBlur).length
      } else {
        return 0
      }
    },
    progressArea() {
      let occData = [];
      let obj = {
        min: 0,
        max: 0,
      }
      let values = 0;
      this.areas.forEach(area => {
        const occRateData = this.areaOccrateData[area.objectId];
        if (occRateData) {
          occData.push({
            ...area,
            dataOccRate: occRateData
          });
        }
      });

      if (this.areaOccrateType === 'rentalRate') {
        values = occData.map(item => item.dataOccRate.occupiedPercent);
      } else if (this.areaOccrateType === 'totalIncome') {
        values = occData.map(item => item.dataOccRate.totalValue);
      } else if (this.areaOccrateType === 'incomeMetres') {
        values = occData.map(item => item.dataOccRate.totalValueMulSize);
      }
      obj = {
        min: values.length > 0 ? Math.min(...values) : 0,
        max: values.length > 0 ? Math.max(...values) : 0,
      }
      return obj;
    }
  },
  data() {
    return {
      isLoading: false,
      contractId: null,
      isContractDialog: false,
      value: 1,
      color: "#444444FF",
      strokeColor: "#000000",
      stageConfig: {
        width: 0,
        height: 0,
        draggable: true
      },
      object: [],
      selectedShapeName: "",
      colorDialog: false,
      computeAreas: [],
      addAreaDialog: false,
      testtest: false,
      areaPlans: [],
      // isEdit: true,
      selectToolBar: 0,
      searchArea: "",
      bgObject: null,
      saveList: [],
      viewboxScale: 1,
      isUploadImageDialog: false,
      tempArea: null,
      isAreaManageDialog: false,
      isRemoveAreaDialog: false,
      isSaveing: false,
      isAddAreaDialog: false,
      isSortArea: false,
      isAreaMenu: false,
      selectedTooltipName: "",
      isSuccess: false,
      isError: false,
      isMounted: false,
      hashImage: {},
      selectPlan: null,
      isAreaDetailDialog: false,
      isInterestDialog: false,
      tempAreaPlan: null,
      isSelectCustomerDialog: false,
      isCreateContractDialog: false,
      imageSlip: null,
      imageBooking: null,
      imageAreaInterest: null,
      imageDueDate: null,
      imageAlmostExprired: null,
      imageExpried: null,
      imageLessThanMeter: null,
      isChangeOrder: false,
      sortBy: "order",
      sortDesc: false,
      renderKey: 0,
      isAreaGeoDialog: false,
      tooltipTimeOut: null,
      lastCenter: null,
      lastDist: 0,
      tempAreas: null,
      isLoadingPercentDialog: false,
      loadingFinal: 0,
      loadingInitial: 0,
      sortableArea: null,
      project: null,
      search: "",
      selectProduct: null,
      productCategoryOptions: [],
      productOptions: [],
      selectStatus: null,
      statusOption: [],
      tooltipVisible: false,
      tooltipData: {
        id: "",
        stallName: "-",
        size: "",
        businessName: "-",
        fullName: "-",
        productList: "-",
        statusName: "-",
        isPaymentApprove: false,
        contractId: null,
        bookingId: null,
        rentalRate: null,
        income: null,
        rankRentalRate: null,
        rankIncomeMarket: null,
        isContractExpired: false,
        isAlmostExpired: false,
        dateExprired: "",
        isLessThanMeter: false,
        meterLessThanMeter: [],
      },
      areaOccrateType: "rentalRate",
      areaOccrateOption: [
        { text: this.$t('area.rental_rate'), value: 'rentalRate' },
        { text: this.$t('project.total_income'), value: 'totalIncome' },
        { text: this.$t('project.income_per_square_meter'), value: 'incomeMetres' },
      ],
      localSelectMarketArea: this.selectMarketArea,
      market: null,
      isSavePlanConfirmDialog: false,
      isResetPlanConfirmDialog: false,
      isSortConfirmDialog: false,
    };
  },
  async created() {
    await this.getMarketArea();
    this.project = this.market.project
    this.initAreaPlan();
    this.$forceUpdate();
  },
  mounted() {
    this.onResize();
    this.repaint();
    let _this = this;
    document.body.addEventListener("keydown", function (e) {
      if (_this.selectPlan && e.keyCode == 46) {
        if (_this.selectPlan.type == "area") {
          _this.removePlan();
        } else if (_this.selectPlan.type == "market") {
          _this.removeImage();
        }
      }
    });
    this.$eventBus.$on("updateAreaPlan", async () => {
      if (
        this.$route.fullPath ==
        `/project/${this.$route.params.projectId}/market/${this.$route.params.marketId}/view`
      ) {
        await this.getMarketArea();
        this.initAreaPlan();
        this.$forceUpdate();
      }
    });
  },
  beforeUpdate() {
    // this.renderKey += 1;
  },
  methods: {
    ...mapMutations({
      setCurrentArea: "area/setCurrentArea"
    }),
    ...mapActions({
      getMarket: "markets/getMarket"
    }),
    async loadData() {
      await this.getMarketArea();
      this.initAreaPlan();
      this.$forceUpdate();
    },
    onClickPlan(areaPlan) {
      // if (areaPlan.isBlur) return false
      if (this.mode !== 'occrate') {
        if (areaPlan?.area)
          this.setCurrentArea(areaPlan.area)
        if (!this.isSelect) {
          this.tempAreaPlan = areaPlan;
          setTimeout(() => {
            if (areaPlan.areaBooking || areaPlan.numOfAreaBooking) {
              this.isContractDialog = true;
            } else if (!areaPlan.isOccupied && !areaPlan.areaInterest) {
              // this.isSelectCustomerDialog = true;
              this.isContractDialog = true;
            } else if (!areaPlan.isOccupied && areaPlan.areaInterest) {
              this.isInterestDialog = true;
            } else if (areaPlan.isOccupied && !areaPlan.areaInterest) {
              this.isContractDialog = true;
            } else {
              this.isAreaDetailDialog = true;
            }
          }, 100);
        } else {
          if (areaPlan.isCanSelect) {
            if (!areaPlan.isSelect && this.selectLimit) {
              if (
                this.areaPlans.filter(d => d.isSelect).length < this.selectLimit
              ) {
                areaPlan.isSelect = !areaPlan.isSelect;
                let selectAreas = this.areaPlans
                  .filter(d => d.isSelect)
                  .map(d => d.area);
                this.$emit("update:selectAreas", selectAreas);
              } else {
                this.$toast.show({
                  content: this.$t('area.can_select_only', { select: this.selectLimit }),
                  color: "error"
                });
              }
            } else {
              if (this.singleSelect) {
                this.areaPlans.map(d => (d.isSelect = false));
              } else {
              }
              areaPlan.isSelect = !areaPlan.isSelect;
              let selectAreas = this.areaPlans
                .filter(d => d.isSelect)
                .map(d => d.area);
              this.$emit("update:selectAreas", selectAreas);
            }
          }
        }
      }
    },
    async createContractDialog(customer) {
      this.isLoading = true;
      try {
        await this.$store.dispatch("customer/getCustomer", {
          id: customer.objectId
        });
        this.isSelectCustomerDialog = false;
        this.isCreateContractDialog = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    repaint() {
      setTimeout(() => this.$redrawVueMasonry(), 1500);
    },
    initAreaPlan() {
      let date = new Date();
      this.areaPlans = [];
      for (let [index, area] of this.areas.entries()) {
        let layout = area.layout;
        if (layout && Object.keys(layout).length) {
          let data = {};
          data.area = area;
          data.objectId = area.objectId;
          data.isOccupied = area.isOccupied;
          data.name = area.name;
          data.id = area.objectId;
          data.contract = area.contract;
          // data.areaInterest = area.areaInterest;
          data.numOfAreaBooking = area.numOfAreaBooking;
          data.areaBooking = area.areaBooking;
          data.products = area.products;
          data.currentProducts = area.currentProducts;
          data.size = area.size || 0;
          data.type = "area";
          data.status = area.status;
          data.isSelect = false;
          data.isBlur = false
          data.layout = {
            x: layout.x || 0,
            y: layout.y || 0,
            width: layout.width || 100,
            height: layout.height || 100,
            scaleX: layout.scaleX || 1,
            scaleY: layout.scaleY || 1,
            rotation: layout.rotation || 0,
            shapeType: layout.shapeType || "konva-rect"
          };

          let fill = "#dadbdd";
          let stroke = "#dadbdd";
          let textColor = "#333a46";
          let status = this.$t('empty');
          if (!this.isEdit) {
            if (this.isSelect) {
              data.areaInterest = null;
              data.numOfAreaBooking = 0;
              data.isCanSelect = this.vacancyAreas.find(
                d => d.objectId == area.objectId
              )
                ? true
                : false;
              data.areaBooking = this.areaBookings
                ? this.areaBookings.find(d => d.area.objectId == area.objectId)
                : null;
              if (!data.isCanSelect) {
                fill = "#f0556c";
                stroke = "#f0556c";
                textColor = "#ffffff";
              } else {
                fill = "#18bc9b";
                stroke = "#18bc9b";
                textColor = "#ffffff";
                if (area && area.statusBooking && area.statusBooking.color == 'error') {
                  fill = "#f0556c";
                  stroke = "#f0556c";
                  status = this.$t('contract.in_contract')
                  // data.isCanSelect = false
                } else if (area && area.statusBooking && area.statusBooking.color == 'info') {
                  fill = "#459bef";
                  stroke = "#459bef";
                  status = this.$t('area.renter_end_date')
                }
              }
            } else {
              if (this.mode != 'occrate') {
                if (area.isOccupied) {
                  fill = "#18bc9b";
                  stroke = "#18bc9b";
                  textColor = "#ffffff";
                  status = this.$t('invoice.no_pending_invoice');
                  if (area.contract) {
                    data.businessName = area.contract.businessName || ""
                    if (area.contract.billingData) {
                      data.customerName = area.contract.billingData.name || ""
                    }
                    if (area.contract.isEscaped) {
                      fill = "#3e3e45";
                      stroke = "#3e3e45";
                      textColor = "#ffffff";
                      status = this.$t('bill.bad_debt');
                    } else if (!area.contract.isPaid) {
                      fill = "#f0556c";
                      stroke = "#f0556c";
                      textColor = "#ffffff";
                      status = this.$t('payment.pending');
                    }
                    if (area.contract.isSuspend && area.areaBooking) {
                      data.businessName = area.areaBooking?.booking?.businessName || ""
                      fill = "#459bef";
                      stroke = "#f5ba5b";
                      textColor = "#ffffff";
                      status = this.$t('suspend.suspend_sale');
                    } else if (area.contract.isSuspend) {
                      fill = "#f5ba5b";
                      stroke = "#f5ba5b";
                      textColor = "#ffffff";
                      status = this.$t('suspend.suspend_sale');
                    }
                  }
                  if (area.areaBooking?.booking?.customer) {
                    let customer = new Customer(area.areaBooking?.booking?.customer)
                    data.customerName = customer.fullName
                  }
                } else {
                  if (area.areaBooking) {
                    data.businessName = area.areaBooking?.booking?.businessName || ""
                    if (area.areaBooking?.booking?.customer) {
                      let customer = new Customer(area.areaBooking?.booking?.customer)
                      data.customerName = customer.fullName
                    }
                    fill = "#459bef";
                    stroke = "#459bef";
                    textColor = "#ffffff";
                    status = this.$t('area.renter_daily_market');
                  }
                }
              } else {
                if (this.areaOccrateData) {
                  let areaData = this.areaOccrateData[data.id];
                  let percent = 0;
                  if (this.areaOccrateType === 'rentalRate') {
                    percent = areaData.occupiedPercent
                  } else if (this.areaOccrateType === 'totalIncome') {
                    percent = areaData.totalValuePercentInMarket;
                  } else if (this.areaOccrateType === 'incomeMetres') {
                    percent = areaData.totalValueMulSizePercentInMarket;
                  }
                  let startColor = "#C9C9C9";
                  let endColor = "#2F7E33";
                  let hexColor = this.getGradientColor(startColor, endColor, percent);

                  fill = hexColor;
                  stroke = hexColor;
                  textColor = "#ffffff";
                  status = "";
                }
              }
            }
          }
          data.style = {
            fill: fill,
            stroke: stroke,
            textColor: textColor,
            status: status
          };
          this.areaPlans.push(data);
        }

        for (let area of this.selectAreas || []) {
          if (this.areaPlans.find(d => d.id == area.objectId))
            this.areaPlans.find(d => d.id == area.objectId).isSelect = true
        }

        for (let product of area.currentProducts) {
          if (product.productCategory) {
            this.productCategoryOptions.push({
              value: `[${this.$t('asset.category')}] ${product.productCategory.name}`,
              text: `[${this.$t('asset.category')}] ${product.productCategory.name}`,
              categoryName: product.productCategory.name,
              type: "category"
            });
          }

          this.productOptions.push({
            value: product.name,
            text: product.name,
            productName: product.name,
            type: "product"
          });
        }

        // this.statusOption.push(
        //   { 
        //     value: area.status,
        //     text: area.statusText, 
        //     color: "red white--text",
        //     colorBar: "#F44336" 
        //   }
        // )
      }

      if (this.isBooking) {
        this.statusOption = []
        this.statusOption.push({
          value: 0,
          text: this.$t('area.empty_stall'),
          color: "red white--text",
          colorBar: "#F44336"
        })
        this.statusOption.push({
          value: 1,
          text: this.$t('area.not_available_stall'),
          color: "green white--text",
          colorBar: "#4CAF50"
        })
      }

      let objects = []
      if (this.project && this.project.layoutType == 1) {
        if (this.project.layout && this.project.layout.objects)
          objects = this.project.layout.objects
      } else {
        if (this.market && this.market.layout && this.market.layout.objects)
          objects = this.market.layout.objects
      }
      if (objects && objects.length) {
        for (let object of objects) {
          if (object && object.layout && object.layout.imageUrl) {
            if (!this.hashImage[object.layout.imageUrl])
              this.hashImage[object.layout.imageUrl] = object.layout.imageUrl;
            const image = new window.Image();
            image.src = object.layout.imageUrl;
            image.onload = () => {
              this.image = image;
              let data = {
                objectId: object.objectId,
                type: "market",
                layout: {
                  x: object.layout.x,
                  y: object.layout.y,
                  width: image.width,
                  height: image.height,
                  scaleX: object.layout.scaleX,
                  scaleY: object.layout.scaleY,
                  rotation: object.layout.rotation,
                  image: image,
                  imageUrl: object.layout.imageUrl
                }
              };
              this.areaPlans.unshift(data);
            };
          }
        }
      }

      const imageSlip = new window.Image();
      imageSlip.src = require(`../assets/images/money-approve.svg`);
      imageSlip.onload = () => {
        this.imageSlip = imageSlip;
      };
      const imageBooking = new window.Image();
      imageBooking.src = require(`../assets/images/booking-stall-icon.svg`);
      imageBooking.onload = () => {
        this.imageBooking = imageBooking;
      };
      const imageAreaInterest = new window.Image();
      imageAreaInterest.src = require(`../assets/images/areaInterest-icon.svg`);
      imageAreaInterest.onload = () => {
        this.imageAreaInterest = imageAreaInterest;
      };
      const imageDueDate = new window.Image();
      imageDueDate.src = require(`../assets/images/overdue.svg`);
      imageDueDate.onload = () => {
        this.imageDueDate = imageDueDate;
      };
      const imageAlmostExprired = new window.Image();
      imageAlmostExprired.src = require(`../assets/images/contract-expire-1.svg`);
      imageAlmostExprired.onload = () => {
        this.imageAlmostExprired = imageAlmostExprired;
      };
      const imageExpried = new window.Image();
      imageExpried.src = require(`../assets/images/contract-expire-2.svg`);
      imageExpried.onload = () => {
        this.imageExpried = imageExpried;
      };

      const imageLessThanMeter = new window.Image();
      imageLessThanMeter.src = require(`../assets/images/meterprepaid.svg`);
      imageLessThanMeter.onload = () => {
        this.imageLessThanMeter = imageLessThanMeter;
      };

      this.prepareData();
    },
    async getMarketArea() {
      if (this.marketId) {
        this.$route.params.marketId = this.marketId
      }
      this.market = await this.getMarket({ marketId: this.$route.params.marketId, force: true })
      await this.$store.dispatch("markets/getMarketArea", {
        id: this.$route.params.marketId
      });
    },
    prepareData() {
      let booking = this.summaryData && this.summaryData.booking ? this.summaryData.booking : null;
      let invoice = this.summaryData && this.summaryData.invoice ? this.summaryData.invoice : null;
      let meters = this.summaryData && this.summaryData.meter ? this.summaryData.meter : null;
      let ageExpireStatus = 90;

      for (const area of this.areaPlans) {

        area.statusPrepare = [];

        if (this.market?.setting) {
          if (this.market.setting.contractExpiredThresholdDays) {
            ageExpireStatus = this.market.setting.contractExpiredThresholdDays
          }
        }

        if (area.areaBooking && area.areaBooking.type == 'daily') {
          area.statusPrepare.push(
            {
              text: this.$t('area.daily_renter_market'),
              value: 'isDaily',
            },
          );
        }
        if (!area.areaBooking || (area.contract && area.contract.isSuspend)) {
          let t = this.$t('area.empty_stall_not_renter');
          let v = 'isEmpty';
          if (area.status == 4) {
            t = this.$t('bill.bad_debt');
            v = 'isBadDebt';
          } else if (area.status == 3) {
            t = this.$t('suspend.renter_monthly_market_that_suspend');
            v = 'isContractSuspension';
          } else if (area.status == 2) {
            t = this.$t('area.monthly_renter_market_that_not_debt');
            v = 'isNoOutStanding';
          } else if (area.status == 1) {
            t = this.$t('area.monthly_renter_market_that_have_debt');
            v = 'isOutStanding';
          }
          area.statusPrepare.push(
            {
              text: t,
              value: v,
            },
          );
        }

        if (booking && booking[area.objectId] &&
          ((booking[area.objectId] && booking[area.objectId].dailyBooking) ||
            (booking[area.objectId] && booking[area.objectId].monthlyBooking))) {
          area.statusPrepare.push(
            {
              text: this.$t('booking.have_booking_stall'),
              value: 'isBooking',
            },
          );
        }

        if (booking && booking[area.objectId] && booking[area.objectId].areaInterest) {
          area.statusPrepare.push(
            {
              text: this.$t('area.have_customer_interest_stall'),
              value: 'isInterested',
            },
          );
        }

        if (meters && meters[area.objectId]) {
          const meterList = meters[area.objectId] || [];
          if (area.areaBooking || (area.contract && area.contract.isActive)) {
            if (meterList.some(mt => mt.meter.digitalMeterData && mt.meter.digitalMeterData.type === "prepaid" && mt.isLowUnit)) {
              area.statusPrepare.push({
                text: this.$t('meter.meter_is_less_than_minimum_unit'),
                value: 'isLessThanMeter',
              });
            }
            if ((area.contract && area.contract.isPaymentApprove)
              || (area.areaBooking && area.areaBooking.booking && area.areaBooking.booking.isPaymentApprove)
              && (meterList.some(mt => mt.meter.isPaymentApprove))) {
              area.statusPrepare.push({
                text: this.$t('area.renter_notify_payment_this_stall'),
                value: 'isPayment',
                dialog: 'Bill',
              });
            } else if (meterList.some(mt => mt.meter.isPaymentApprove)) {
              area.statusPrepare.push({
                text: this.$t('area.renter_notify_payment_this_stall'),
                value: 'isPayment',
                dialog: 'MeterDigital',
              });
            }
          }
        } else {
          if ((area.contract && area.contract.isPaymentApprove) || (area.areaBooking && area.areaBooking.booking && area.areaBooking.booking.isPaymentApprove)) {
            area.statusPrepare.push(
              {
                text: this.$t('area.renter_notify_payment_this_stall'),
                value: 'isPayment',
                dialog: 'Bill',
              },
            );
          }
        }

        if ((area.contract && area.contract.objectId && invoice && invoice[area.contract.objectId]) ||
          (area.areaBooking && area.areaBooking.booking &&
            area.areaBooking.booking.objectId && invoice &&
            invoice[area.areaBooking.booking.objectId])) {
          area.statusPrepare.push(
            {
              text: this.$t('bill.overdue_bill'),
              value: 'isOverdueBill',
            },
          );
        }

        if (area.contract) {
          if (area.contract.endDate && area.contract.endDate.iso) {
            let ageExpire = this.$moment(area.contract.endDate.iso).diff(this.$moment(), "days");
            if (ageExpire < 0) {
              area.statusPrepare.push(
                {
                  text: this.$t('contract.contract_expired'),
                  value: 'isContractExpired',
                },
              );
            } else if (ageExpire == 0) {
              area.statusPrepare.push(
                {
                  text: this.$t('contract.contract_will_expired_in'),
                  value: 'isAlmostExpired',
                  dateExprired: ageExpire,
                },
              );
            } else if (ageExpire > 0 && ageExpire <= ageExpireStatus) {
              area.statusPrepare.push(
                {
                  text: this.$t('contract.contract_will_expired_in'),
                  value: 'isAlmostExpired',
                  dateExprired: ageExpire,
                },
              );
            }
          }
        }

        for (const st of area.statusPrepare) {
          let s = this.statusOption.find((a) => a.text === st.text);
          if (!s) {
            this.statusOption.push(
              {
                value: st.value,
                text: st.text,
                color: "red white--text",
                colorBar: "#F44336"
              }
            )
          }
        }
      }
    },
    getGradientColor(startColor, endColor, percent) {
      const hexToRgb = hex => ({
        r: parseInt(hex.substring(1, 3), 16),
        g: parseInt(hex.substring(3, 5), 16),
        b: parseInt(hex.substring(5, 7), 16)
      });

      const rgbToHex = ({ r, g, b }) =>
        `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;

      let startRGB = hexToRgb(startColor);
      let endRGB = hexToRgb(endColor);

      let resultRGB = {
        r: Math.round(startRGB.r + (endRGB.r - startRGB.r) * (percent / 100)),
        g: Math.round(startRGB.g + (endRGB.g - startRGB.g) * (percent / 100)),
        b: Math.round(startRGB.b + (endRGB.b - startRGB.b) * (percent / 100))
      };

      return rgbToHex(resultRGB);
    },
    showContractDialog(contractId) {
      this.contractId = contractId;
      this.isContractDialog = true;
    },
    onResize() {
      setTimeout(() => {
        let width = this.$refs.viewbox.offsetWidth - 4
        let height = this.$refs.viewbox.offsetHeight - 4
        this.stageConfig = {
          width: width,
          height: height,
          draggable: true,
        };
      }, 100);
    },
    onWheel(e) {
      e.evt.preventDefault();
      const stage = this.$refs.stage.getNode();
      const oldScale = stage.scaleX();

      const pointer = stage.getPointerPosition();

      const mousePointTo = {
        x: (pointer.x - stage.x()) / oldScale,
        y: (pointer.y - stage.y()) / oldScale
      };

      const newScale =
        Math.round(
          (e.evt.deltaY < 0 ? oldScale + 0.1 : oldScale - 0.1 || 0) * 10
        ) / 10;

      if (newScale > 0 && newScale <= 2) {
        this.viewboxScale = newScale;
        stage.scale({ x: newScale, y: newScale });
        const newPos = {
          x: pointer.x - mousePointTo.x * newScale,
          y: pointer.y - mousePointTo.y * newScale
        };
        stage.position(newPos);
      }
    },
    onPinch(e) {
      function getDistance(p1, p2) {
        return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
      }
      function getCenter(p1, p2) {
        return {
          x: (p1.x + p2.x) / 2,
          y: (p1.y + p2.y) / 2
        };
      }

      e.evt.preventDefault();
      var touch1 = e.evt.touches[0];
      var touch2 = e.evt.touches[1];

      if (touch1 && touch2) {
        const stage = this.$refs.stage.getNode();
        if (this.stageConfig.draggable) {
          this.stageConfig.draggable = false;
        }

        var p1 = {
          x: touch1.clientX,
          y: touch1.clientY
        };
        var p2 = {
          x: touch2.clientX,
          y: touch2.clientY
        };

        if (!this.lastCenter) {
          this.lastCenter = getCenter(p1, p2);
          return;
        }
        var newCenter = getCenter(p1, p2);

        var dist = getDistance(p1, p2);

        if (!this.lastDist) {
          this.lastDist = dist;
        }

        // local coordinates of center point
        var pointTo = {
          x: (newCenter.x - stage.x()) / stage.scaleX(),
          y: (newCenter.y - stage.y()) / stage.scaleX()
        };

        var scale = stage.scaleX() * (dist / this.lastDist);

        stage.scaleX(scale);
        stage.scaleY(scale);

        // calculate new position of the stage
        var dx = newCenter.x - this.lastCenter.x;
        var dy = newCenter.y - this.lastCenter.y;

        var newPos = {
          x: newCenter.x - pointTo.x * scale + dx,
          y: newCenter.y - pointTo.y * scale + dy
        };

        stage.position(newPos);

        this.lastDist = dist;
        this.lastCenter = newCenter;
      }
    },
    onEndPinch() {
      this.lastDist = 0;
      this.lastCenter = null;
      this.stageConfig.draggable = true;
    },
    zoom(type) {
      const stage = this.$refs.stage.getNode();
      const oldScale = stage.scaleX();
      let newScale;

      if (type == "out") newScale = Math.round((oldScale - 0.1 || 0) * 10) / 10;
      else newScale = Math.round((oldScale + 0.1 || 0) * 10) / 10;

      if (newScale > 0 && newScale <= 2) {
        this.viewboxScale = newScale;
        stage.scale({ x: newScale, y: newScale });
      }
    },
    rndStr(len) {
      let text = "";
      let chars = "1234567890abcdef";

      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return text;
    },
    handleTransformEnd(e) {
      const areaPlan = this.areaPlans.find(
        r =>
          r.objectId ===
          (this.selectedShapeName != ""
            ? this.selectedShapeName
            : e.target.attrs.name)
      );
      let index = this.saveList.findIndex(d => d.objectId == areaPlan.objectId);

      let layout = JSON.parse(JSON.stringify(areaPlan.layout));
      layout.rotation = e.target.rotation();
      layout.scaleX = e.target.scaleX();
      layout.scaleY = e.target.scaleY();
      layout.x = e.target.x();
      layout.y = e.target.y();

      if (areaPlan.type == "area") {
        layout.width = e.target.width();
        layout.height = e.target.height();
      }

      if (index > -1) {
        this.saveList[index].layout = layout;
      } else {
        let tempAreaPlan = JSON.parse(JSON.stringify(areaPlan));
        tempAreaPlan.layout = layout;
        this.saveList.push(tempAreaPlan);
      }
    },
    handleStageMouseDown(e) {
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = "";
        this.updateTransformer();
        return;
      }

      const clickedOnTransformer =
        e.target.getParent().className === "Transformer";
      if (clickedOnTransformer) {
        return;
      }

      const name = e.target.name();
      const rect = this.areaPlans.find(r => r.objectId === name);
      if (rect) {
        if (this.selectToolBar == 1 && rect.type == "market") {
          this.selectedShapeName = name;
        } else if (this.selectToolBar == 0 && rect.type == "area") {
          this.selectedShapeName = name;
        } else {
          this.selectedShapeName = "";
        }
      } else {
        this.selectedShapeName = "";
      }
      this.updateTransformer();
    },
    updateTransformer() {
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;
      const rect = this.areaPlans.find(r => r.objectId === selectedShapeName);
      this.selectPlan = rect;

      const selectedNode = stage.findOne("." + selectedShapeName);
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        transformerNode.nodes([selectedNode]);
      } else {
        transformerNode.nodes([]);
      }
    },
    async saveObject() {
      this.isLoading = true;
      try {
        for (let data of this.saveList) {
          if (data.type == "area") {
            await this.$store.dispatch("area/updateArea", {
              id: data.objectId,
              name: data.name,
              layout: data.layout
            });
          }
        }

        if (this.saveList.filter(d => d.type == "market").length > 0) {
          let objects = [];
          for (let plan of this.areaPlans) {
            if (plan.type == "market") {
              let tempPlan = JSON.parse(JSON.stringify(plan));
              let tempSave = this.saveList.find(
                d => d.objectId == plan.objectId
              )
                ? JSON.parse(
                  JSON.stringify(
                    this.saveList.find(d => d.objectId == plan.objectId)
                  )
                )
                : null;

              if (tempSave) {
                if (tempSave.layout) {
                  tempPlan.layout = tempSave.layout;
                  if (tempPlan.layout && tempPlan.layout.image)
                    delete tempPlan.layout.image;
                  objects.push(tempPlan);
                }
              } else {
                if (tempPlan.layout && tempPlan.layout.image)
                  delete tempPlan.layout.image;
                objects.push(tempPlan);
              }
            }
          }
          await this.$store.dispatch("markets/updateMarket", {
            id: this.market.objectId,
            layout: {
              objects: objects
            }
          });
        }

        this.isLoading = false;
        this.isSuccess = true;
        this.saveList = [];
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    closeToolBar() {
      this.selectToolBar = null;
    },
    focusPlan(area) {
      let areaPlan = this.areaPlans.find(d => d.objectId == area.objectId);
      if (areaPlan) {
        let layout = areaPlan.layout;
        let stage = this.$refs.stage.getNode();
        let stageWidth = stage.width();
        let stageHeight = stage.height();
        let scale = stage.scaleX();

        let x =
          stageWidth / 2 - (layout.x * scale + (layout.width * scale) / 2);
        let y =
          stageHeight / 2 - (layout.y * scale + (layout.height * scale) / 2);
        stage.position({ x, y });

        this.selectedShapeName = areaPlan.objectId;
        this.updateTransformer();
      }
    },
    createPlan(area) {
      let stage = this.$refs.stage.getNode();
      let stageWidth = stage.width();
      let stageHeight = stage.height();

      let data = {};
      data.objectId = area.objectId;
      data.isOccupied = area.isOccupied;
      data.name = area.name;
      data.contract = area.contract;
      data.areaInterest = area.areaInterest;
      data.type = "area";
      data.layout = {
        x: stageWidth / 2 - 50,
        y: stageHeight / 2 - 50,
        width: 100,
        height: 100,
        scaleX: 1,
        scaleY: 1,
        rotation: 0,
        shapeType: "konva-rect"
      };

      let fill = "#dadbdd";
      let stroke = "#dadbdd";
      let textColor = "#333a46";
      let status = this.$t('empty');

      // if(area.isOccupied){
      //   fill = "green"
      //   stroke = "#6b9c38"
      //   textColor = "#ffffff"
      //   status = "ไม่มีหนี้ค้าง"
      //   if(area.contract && !area.contract.isPaid){
      //     fill = "red"
      //     stroke = "#e37266"
      //     textColor = "#ffffff"
      //     status = "ค้างชำระ"
      //   }
      // }

      // if(data.areaInterest){
      //   stroke = "#F8BF2F"
      // }

      data.style = {
        fill: fill,
        stroke: stroke,
        textColor: textColor,
        status: status
      };
      this.areaPlans.push(data);

      setTimeout(() => {
        this.selectedShapeName = data.objectId;
        this.updateTransformer();
        let sindex = this.saveList.findIndex(d => d.objectId == data.objectId);
        if (sindex > -1) {
          this.saveList[sindex] = JSON.parse(JSON.stringify(data));
        } else {
          this.saveList.push(JSON.parse(JSON.stringify(data)));
        }
      }, 100);
    },
    editShapeType(shapeType) {
      if (this.selectedShapeName) {
        let areaPlan = this.areaPlans.find(
          d => d.objectId === this.selectedShapeName
        );
        if (areaPlan) {
          areaPlan.layout.shapeType = shapeType;
          this.selectedShapeName = "";
          this.updateTransformer();
          setTimeout(() => {
            this.selectedShapeName = areaPlan.objectId;
            this.updateTransformer();
          }, 100);

          let index = this.saveList.findIndex(
            d => d.objectId == areaPlan.objectId
          );
          if (index > -1) {
            this.saveList[index].layout = areaPlan.layout;
          } else {
            let tempAreaPlan = JSON.parse(JSON.stringify(areaPlan));
            this.saveList.push(tempAreaPlan);
          }
        }
      }
    },
    onUploadImageSuccess(file) {
      // let file = {
      //   name: "aaaaa",
      //   url: "https://konvajs.org/assets/yoda.jpg"
      // }
      if (!this.hashImage[file.url]) this.hashImage[file.url] = file.url;
      this.$forceUpdate();
    },
    createImage(url) {
      const image = new window.Image();
      image.src = url;
      image.onload = () => {
        let data = {};
        let stage = this.$refs.stage.getNode();
        let stageWidth = stage.width();
        let stageHeight = stage.height();
        let date = new Date();
        data = {
          objectId: `${date.getTime()}`,
          type: "market",
          layout: {
            x: stageWidth / 2 - image.width / 2,
            y: stageHeight / 2 - image.height / 2,
            width: image.width,
            height: image.height,
            scaleX: 1,
            scaleY: 1,
            rotation: 0,
            image: image,
            imageUrl: url
          }
        };

        let index = this.areaPlans.findIndex(d => d.objectId == data.objectId);
        if (index > -1) {
          this.areaPlans[index].layout = data.layout;
        } else {
          this.areaPlans.unshift(data);
        }

        let sindex = this.saveList.findIndex(d => d.objectId == data.objectId);
        if (sindex > -1) {
          this.saveList[sindex] = JSON.parse(JSON.stringify(data));
        } else {
          this.saveList.push(JSON.parse(JSON.stringify(data)));
        }

        setTimeout(() => {
          this.selectedShapeName = data.objectId;
          this.updateTransformer();
        }, 100);
      };
    },
    editArea(area) {
      this.tempArea = area;
      this.isAreaManageDialog = true;
    },
    editGeoPoint(area) {
      this.tempArea = area;
      this.isAreaGeoDialog = true;
    },
    dialogRemoveArea(area) {
      this.tempArea = area;
      this.isRemoveAreaDialog = true;
    },
    async removeArea() {
      this.isSaveing = true;
      try {
        await this.$store.dispatch("area/removeArea", this.tempArea.objectId);

        let index = this.areaPlans.findIndex(
          d => d.objectId == this.tempArea.objectId
        );
        if (index > -1) this.areaPlans.splice(index, 1);

        let sIndex = this.saveList.findIndex(
          d => d.objectId == this.tempArea.objectId
        );
        if (sIndex > -1) this.saveList.splice(sIndex, 1);

        this.isRemoveAreaDialog = false;
        this.isSaveing = false;
      } catch (error) {
        this.isError = true;
        this.isSaveing = false;
      }
    },
    removePlan() {
      let index = this.areaPlans.findIndex(
        d => d.objectId == this.selectPlan.objectId
      );
      if (index > -1) this.areaPlans.splice(index, 1);

      let sindex = this.saveList.findIndex(
        d => d.objectId == this.selectPlan.objectId
      );
      if (sindex > -1) {
        this.saveList[sindex] = {
          objectId: this.selectPlan.objectId,
          type: "area",
          layout: {}
        };
      } else {
        this.saveList.push({
          objectId: this.selectPlan.objectId,
          type: "area",
          layout: {}
        });
      }
      this.selectedShapeName = "";
      this.updateTransformer();
    },
    removeImage() {
      this.bgObject = null;
      let index = this.areaPlans.findIndex(
        d => d.objectId == this.selectedShapeName
      );
      if (index > -1) {
        this.areaPlans[index].layout = null;
      }

      let sindex = this.saveList.findIndex(
        d => d.objectId == this.selectedShapeName
      );
      if (sindex > -1) {
        this.saveList[sindex] = JSON.parse(
          JSON.stringify(this.areaPlans[index])
        );
      } else {
        this.saveList.push(JSON.parse(JSON.stringify(this.areaPlans[index])));
      }
      this.selectedShapeName = "";
      this.updateTransformer();
    },
    handleMouseOut(e) {
      this.selectedTooltipName = "";
      const stage = e.target.getStage();
      if (stage) {
        stage.container().style.cursor = "default";
      }
      this.tooltipVisible = false;
      document.body.removeEventListener("mousemove", this.mouseMoveHandler);
    },
    handleMouseOver(e, obj) {
      if (e.target.name() && e.target.name() != this.selectedTooltipName) {
        this.selectedTooltipName = e.target.name();
      }
      const stage = e.target.getStage();
      if (stage) {
        stage.container().style.cursor = "pointer";
      }
      if ((!this.isEdit || this.isSelect) && this.selectedTooltipName == obj.objectId && !obj.isCanSelect) {
        document.body.addEventListener("mousemove", this.mouseMoveHandler);
        this.setTooltipData(obj);
        this.tooltipVisible = true;
      }
    },
    setTooltipData(areaPlan) {
      this.tooltipData.id = "";
      this.tooltipData.stallName = "";
      this.tooltipData.size = "";
      this.tooltipData.businessName = "";
      this.tooltipData.fullName = "";
      this.tooltipData.productList = "";
      this.tooltipData.statusName = "";
      this.tooltipData.isPaymentApprove = false;
      this.tooltipData.contractId = "";
      this.tooltipData.bookingId = "";
      this.tooltipData.rentalRate = "";
      this.tooltipData.income = "";
      this.tooltipData.rankRentalRate = "";
      this.tooltipData.rankIncomeMarket = "";
      this.tooltipData.isContractExpired = false;
      this.tooltipData.isAlmostExpired = false;
      this.tooltipData.dateExprired = "";
      this.tooltipData.isLessThanMeter = false;
      this.tooltipData.meterLessThanMeter = [];
      if (areaPlan) {
        this.tooltipData.id = areaPlan.id
        this.tooltipData.stallName = areaPlan.name
        this.tooltipData.size = this.$helper.toCurrency(areaPlan.size);
        if (this.mode !== 'occrate') {
          if (this.isSelect) {
            if (areaPlan.contract) {
              if (areaPlan.contract.businessName) {
                this.tooltipData.businessName = areaPlan.contract.businessName;
              }
              if (areaPlan.contract.billingData) {
                this.tooltipData.fullName = areaPlan.contract.billingData.name;
              }
              if (areaPlan.products) {
                let products = areaPlan.products.map(d => d.name).join(", ");
                this.tooltipData.products = products
              }
              if (areaPlan.contract.objectId) {
                this.tooltipData.contractId = areaPlan.contract.objectId;
              }
            } else if (areaPlan.areaBooking) {
              let booking = areaPlan.areaBooking.booking
              if (booking.businessName) {
                this.tooltipData.businessName = booking.businessName;
              }
              if (booking.customer) {
                let customer = new Customer(booking.customer);
                this.tooltipData.fullName = customer.fullName;
              }
              if (areaPlan.areaBooking.products) {
                let productList = areaPlan.areaBooking.products.map(d => d.name).join(",");
                this.tooltipData.productList = productList;
              }
              if (booking.objectId) {
                this.tooltipData.bookingId = booking.objectId;
              }
            }
            if (areaPlan.area.statusBooking && areaPlan.area.statusBooking.subTitle) {
              this.tooltipData.statusName = areaPlan.area.statusBooking.subTitle
            }
          } else {
            if (areaPlan.areaBooking) {
              let booking = areaPlan.areaBooking.booking;
              if (booking.businessName) {
                this.tooltipData.businessName = booking.businessName;
              }
              if (areaPlan.customerName) {
                this.tooltipData.fullName = areaPlan.customerName;
              }
              if (areaPlan.areaBooking.products) {
                this.tooltipData.productList = areaPlan.areaBooking.products && areaPlan.areaBooking.products.length ?
                  areaPlan.areaBooking.products.map(d => d.name).join(", ") : "";
              }
              if (booking.objectId) {
                this.tooltipData.bookingId = booking.objectId;
              }

            } else {
              if (areaPlan.contract) {
                if (areaPlan.contract.businessName) {
                  this.tooltipData.businessName = areaPlan.contract.businessName;
                }
                if (areaPlan.contract.billingData) {
                  this.tooltipData.fullName = areaPlan.contract.billingData.name;
                }
                if (areaPlan.contract.objectId) {
                  this.tooltipData.contractId = areaPlan.contract.objectId;
                }
              }
              if (areaPlan.products) {
                this.tooltipData.productList = areaPlan.products && areaPlan.products.length ?
                  areaPlan.products.map(d => d.name).join(", ") : "";
              }
            }
            this.tooltipData.statusName = "⚪️ " + this.$t('empty');
            if (areaPlan.isOccupied) {
              this.tooltipData.statusName = "🟢 " + this.$t('invoice.no_pending_invoice');
              if (areaPlan.contract) {
                if (areaPlan.contract.isEscaped) {
                  this.tooltipData.statusName = "⚫ " + this.$t('bill.bad_debt');
                } else if (!areaPlan.contract.isPaid) {
                  this.tooltipData.statusName = "🔴 " + this.$t('payment.pending');
                  // if (areaPlan.contract.isPaymentApprove) {
                  //   this.tooltipData.isPaymentApprove = true;
                  // }
                }
                if (areaPlan.contract.isSuspend) {
                  if (areaPlan.areaBooking) {
                    this.tooltipData.statusName = "🟠 " + this.$t('suspend.suspend_sale') + "🔵 " + this.$t('daily');
                  } else {
                    this.tooltipData.statusName = "🟠 " + this.$t('suspend.suspend_sale')
                  }
                }
              }
            } else {
              if (areaPlan.areaBooking) {
                this.tooltipData.statusName = "🔵 " + this.$t('daily');
              }
              if (areaPlan.areaBooking && areaPlan.areaBooking.booking && areaPlan.areaBooking.booking.isPaymentApprove) {
                this.tooltipData.isPaymentApprove = true;
              }
            }
          }

          if (this.summaryData && this.summaryData.meter[areaPlan.objectId]) {
            for (let mt of this.summaryData.meter[areaPlan.objectId]) {
              if (mt.isLowUnit) {
                let lowUnit = mt.lowUnit
                let isLessThanMeter = mt.isLowUnit;
                let obj = {
                  lowUnit,
                  isLessThanMeter
                }
                this.tooltipData.meterLessThanMeter = [obj];
              }
            }
          }

          if (areaPlan.statusPrepare) {
            if (areaPlan.statusPrepare.map(a => a.value).includes('isContractExpired')) {
              this.tooltipData.isContractExpired = true;
            }
            if (areaPlan.statusPrepare.map(a => a.value).includes('isAlmostExpired')) {
              let statusPrepare = areaPlan.statusPrepare.filter(a => a.value == 'isAlmostExpired');
              this.tooltipData.isAlmostExpired = true;
              this.tooltipData.dateExprired = statusPrepare[0].dateExprired;
            }
            if (areaPlan.statusPrepare.map(a => a.value).includes('isLessThanMeter')) {
              this.tooltipData.isLessThanMeter = true;
            }
            if (areaPlan.statusPrepare.map(a => a.value).includes('isPayment')) {
              this.tooltipData.isPaymentApprove = true;
            }
          }
        } else {
          if (this.areaOccrateData) {
            let areaData = this.areaOccrateData[areaPlan.id];
            this.tooltipData.rentalRate = `${this.$helper.toCurrency(areaData.occupiedPercent)} %`;
            this.tooltipData.income = `${this.$helper.toCurrency(areaData.totalValue, null, { isSuffixSign: true })}`;
            this.tooltipData.rankRentalRate = `${this.$t('product.rank', { index: areaData.occupiedDaysRankInMarket })}`;
            this.tooltipData.rankIncomeMarket = `${this.$t('product.rank', { index: areaData.totalValueRankInMarket })}`;
          }
        }
      }
    },
    tooltipText(areaPlan) {
      let text = "";
      if (areaPlan) {
        text = `${areaPlan.name} (${this.$helper.toCurrency(
          areaPlan.size
        )} ${this.$t('square_meter')})`;

        if (this.isSelect) {
          if (areaPlan.contract) {
            if (areaPlan.contract.businessName) {
              text += `\n • ${this.$t('area.shop_name')} : ${areaPlan.contract.businessName}`;
            }
            if (areaPlan.contract.billingData) {
              text += `\n • ${this.$t('contract.contractor_name')} aa : ${areaPlan.contract.billingData.name}`;
            }
            if (areaPlan.products) {
              let productList = areaPlan.products.map(d => d.name).join(",");
              text += productList ? `\n • ${this.$t('product.title')} : ${productList}` : "-";
            }
          } else if (areaPlan.areaBooking) {
            let booking = areaPlan.areaBooking.booking;
            if (booking.businessName) {
              text += `\n • ${this.$t('area.shop_name')} : ${booking.businessName}`;
            }
            if (booking.customer) {
              let customer = new Customer(booking.customer);
              text += `\n • ${this.$t('market.marchant_name')} : ${customer.fullName}`;
            }
            if (areaPlan.areaBooking.products) {
              let productList = areaPlan.areaBooking.products
                .map(d => d.name)
                .join(",");
              text += productList ? `\n • ${this.$t('product.title')} : ${productList}` : "-";
            }
          }
          if (areaPlan.area.statusBooking && areaPlan.area.statusBooking.subTitle) {
            text += `\n • ${this.$t('area.stall_status')} : ${areaPlan.area.statusBooking.subTitle}`;
          }
        } else {
          if (areaPlan.areaBooking) {
            let booking = areaPlan.areaBooking.booking;
            if (booking.businessName) {
              text += `\n • ${this.$t('area.shop_name')} : ${booking.businessName}`;
            }
            if (areaPlan.customerName) {
              text += `\n • ${this.$t('market.marchant_name')} : ${areaPlan.customerName}`;
            }
            if (areaPlan.areaBooking.products) {
              text += `\n • ${this.$t('product.product_in_booking_stall')} : ${areaPlan.areaBooking.products &&
                areaPlan.areaBooking.products.length
                ? areaPlan.areaBooking.products.map(i => i.name).join(", ")
                : "-"
                } `;
            }
          } else {
            if (areaPlan.contract) {
              if (areaPlan.contract.businessName) {
                text += `\n • ${this.$t('area.shop_name')} : ${areaPlan.contract.businessName}`;
              }
              if (areaPlan.contract.billingData) {
                text += `\n • ${this.$t('contract.contractor_name')} : ${areaPlan.contract.billingData.name}`;
              }
            }

            if (areaPlan.products) {
              text += `\n • ${this.$t('product.title')} : ${areaPlan.products && areaPlan.products.length
                ? areaPlan.products.map(i => i.name).join(",")
                : "-"
                } `;
            }
          }

          let status = `• ${this.$t('status')} : ⚪️ ${this.$t('empty')}`;
          if (areaPlan.isOccupied) {
            status = `• ${this.$t('status')} : 🟢 ${this.$t('invoice.no_pending_invoice')}`;
            if (areaPlan.contract) {
              if (!areaPlan.contract.isPaid) {
                status = `• ${this.$t('status')} : 🔴 ${this.$t('payment.pending')}`;
                if (areaPlan.contract.isPaymentApprove) {
                  status += ` (${this.$t('payment.attach_payment_proof')})`;
                }

              }
              if (areaPlan.contract.isSuspend) {
                if (areaPlan.areaBooking) {
                  status = `• ${this.$t('status')} : 🟠 ${this.$t('suspend.suspend_sale')} 🔵 ${this.$t('daily')}`;
                } else {
                  status = `• ${this.$t('status')} : 🟠 ${this.$t('suspend.suspend_sale')}`;
                }
              }
            }
          } else {
            if (areaPlan.areaBooking) {
              status = `• ${this.$t('status')} : 🔵 ${this.$t('daily')}`;
            }
            if (areaPlan.areaBooking && areaPlan.areaBooking.booking && areaPlan.areaBooking.booking.isPaymentApprove) {
              status += ` (${this.$t('payment.attach_payment_proof')})`;
            }
          }
          text += `\n ${status}`;
        }
      }
      return text;
    },
    onSortArea() {
      const _this = this
      const options = {
        animation: 150,
        onUpdate: function (event) {
          _this.sorted(event)
        }
      };
      this.sortableArea = Sortable.create(document.getElementsByTagName("tbody")[0], options);
      this.tempAreas = JSON.parse(JSON.stringify(this.areaTable.items))
      this.sortBy = "order"
      this.sortDesc = false
      this.isSortArea = true
    },
    cancelSortArea() {
      this.areaTable.items = this.tempAreas
      this.isSortArea = false
      this.sortableArea.destroy()
    },
    async sorted(event) {
      const movedItem = this.areaTable.items.splice(event.oldIndex, 1)[0];
      this.areaTable.items.splice(event.newIndex, 0, movedItem);
      let order = 1
      for (let area of this.areaTable.items) {
        area.order = order
        order++
      }
    },
    async saveAreaOrder() {
      let saveAreas = []
      for (let area of this.areaTable.items) {
        if (area.order != this.tempAreas.find(d => d.objectId == area.objectId).order) {
          saveAreas.push(area)
        }
      }
      this.sortableArea.destroy()
      this.isLoading = true
      this.isLoadingPercentDialog = true
      this.loadingInitial = saveAreas.length
      this.loadingFinal = 0
      try {
        for (let area of saveAreas) {
          await this.$store.dispatch("area/updateArea", {
            id: area.objectId,
            order: area.order,
          });
          this.loadingFinal++
        }
        this.isSortArea = false
        this.isLoading = false
        this.isLoadingPercentDialog = false
        this.isSuccess = true
      } catch (err) {
        this.isSortArea = false
        this.isLoading = false
        this.isLoadingPercentDialog = false
        this.isError = true
      }

    },
    handleTouchstart(e) {
      this.selectedTooltipName = "";
      if (e.target.name()) {
        let stage = this.$refs.stage.getNode();
        let shape = stage.find("#" + e.target.name())[0];
        shape.scale({ x: 1.05, y: 1.05 });
        if (shape.constructor.name == "Rect") {
          shape.x(shape.x() - 2.5);
          shape.y(shape.y() - 2.5);
        }
        this.tooltipTimeOut = setTimeout(() => {
          this.selectedTooltipName = shape.name();
          shape.scale({ x: 1, y: 1 });
          if (shape.constructor.name == "Rect") {
            shape.x(shape.x() + 2.5);
            shape.y(shape.y() + 2.5);
          }
        }, 1000);
      }
    },
    handleTouchend(e) {
      if (!this.selectedTooltipName) {
        if (e.target.name()) {
          clearTimeout(this.tooltipTimeOut);
          this.tooltipTimeOut = null;
          let stage = this.$refs.stage.getNode();
          let shape = stage.find("#" + e.target.name())[0];
          shape.scale({ x: 1, y: 1 });
          if (shape.constructor.name == "Rect") {
            shape.x(shape.x() + 2.5);
            shape.y(shape.y() + 2.5);
          }
          let areaPlan = this.areaPlans.find(d => d.objectId == shape.name());
          this.onClickPlan(areaPlan);
        }
      }
    },
    reloadContract(booking) {
      if (
        booking &&
        booking.areaBookings &&
        booking.areaBookings.length &&
        booking.areaBookings[0].area &&
        this.tempAreaPlan.area.objectId == booking.areaBookings[0].area.objectId
      ) {
        if (booking.areaBookings[0].area.contract && this.tempAreaPlan) {
          this.tempAreaPlan.contract = booking.areaBookings[0].area.contract;
        }
        // this.$emit("reloadContract");
      }
    },
    checkBookingAndContract(area) {
      let res = {
        hasBooking: null,
        hasAreaBooking: null,
        hasContract: null,
        isCannotRemove: false
      };
      if (area) {
        res.hasBooking = area.numOfAreaBooking > 0 ? area.numOfAreaBooking : 0;
        res.hasAreaBooking = area.areaBooking ? area.areaBooking : null;
        res.hasContract = area.contract ? area.contract : null;
        res.isCannotRemove =
          area.contract || area.areaBooking || area.numOfAreaBooking > 0
            ? true
            : false;
      }
      return res;
    },
    initSearchAreaPlan() {
      for (let areaPlan of this.areaPlans) {
        let _this = this
        let text = ""
        if (!this.search) this.search = ""
        if (areaPlan.name) text += areaPlan.name + " "
        if (areaPlan.businessName) text += areaPlan.businessName + " "
        if (areaPlan.customerName) text += areaPlan.customerName + " "
        if (text.includes(this.search) && checkProduct() && checkStatus()) {
          areaPlan.isBlur = false
        } else {
          areaPlan.isBlur = true
        }

        function checkProduct() {
          if (_this.selectProduct?.value) {
            let products = areaPlan.currentProducts || []
            if (_this.selectProduct.type == "product") {
              return products.map(a => a.name).includes(_this.selectProduct.productName)
            } else {
              return products.map(a => a.productCategory?.name).includes(_this.selectProduct.categoryName)
            }
          } else {
            return true
          }
        }
        function checkStatus() {
          if (_this.selectStatus?.value) {
            if (_this.isBooking) {
              if (_this.selectStatus.value == 0 && areaPlan.isCanSelect) {
                return true
              } else if (_this.selectStatus.value == 1 && !areaPlan.isCanSelect) {
                return true
              } else {
                return false
              }
            } else {
              if (areaPlan.statusPrepare) {
                return areaPlan.statusPrepare.map(a => a.value).includes(_this.selectStatus.value)
              } else {
                return false
              }
            }
          } else {
            return true
          }
        }
      }
    },
    mouseMoveHandler(e) {
      let tooltipStall = document.getElementById(this.tooltipStallId);
      if (tooltipStall) {
        let positionX = tooltipStall.offsetWidth / 2;
        let positionY = tooltipStall.offsetHeight + 20;
        tooltipStall.style.left = e.clientX - positionX + 'px';
        tooltipStall.style.top = e.clientY - positionY + 'px';
      }
    },
    getCounting(objectId, key) {
      if (this.summaryData && this.summaryData.booking && this.summaryData.booking[objectId]) {
        return this.summaryData.booking[objectId][key] || 0;
      }
      return 0;
    },
    getDueDate(objectId) {
      if (this.summaryData && this.summaryData.invoice && this.summaryData.invoice[objectId] && this.summaryData.invoice && this.summaryData.invoice[objectId][0]) {
        return Helper.diffDays(this.summaryData.invoice[objectId][0].dueDate)
      }
      return false;
    },
    setColorStroke(obj) {
      if (this.mode !== 'occrate') {
        if (obj.isSelect) {
          return '#f5ba5b';
        } else {
          if (!this.isEdit && !this.isSelect) {
            if (obj.contract && obj.contract.isSuspend) {
              return obj.style.stroke
            } else {
              if (this.showImageAreaInterest(obj.id) ||
                this.showImageSlip(obj) ||
                this.showImageBooking(obj.id) ||
                this.showImageDueDate(obj) ||
                this.showImageAlmostExprired(obj) ||
                this.showImageContractExprired(obj) ||
                this.showImageLessThanMeter(obj)
              ) {
                return '#00838F';
              } else {
                return obj.style.stroke
              }
            }
          } else {
            return obj.style.stroke;
          }
        }
      } else {
        return "transparent";
      }
    },
    showImageBooking(objectId) {
      return this.summaryData.booking && this.summaryData.booking[objectId] &&
        (this.summaryData.booking[objectId]?.dailyBooking || this.summaryData.booking[objectId]?.monthlyBooking);
    },
    showImageAreaInterest(objectId) {
      return this.summaryData.booking && this.summaryData.booking[objectId]?.areaInterest;
    },
    showImageSlip(obj) {
      return obj.statusPrepare && obj.statusPrepare.some(st => st.value === 'isPayment');
    },
    showImageDueDate(obj) {
      return (obj.contract && obj.contract.objectId && this.summaryData.invoice && this.summaryData.invoice[obj.contract.objectId]) ||
        (obj.areaBooking && obj.areaBooking.booking && obj.areaBooking.booking.objectId && this.summaryData.invoice && this.summaryData.invoice[obj.areaBooking.booking.objectId])
    },
    showImageAlmostExprired(obj) {
      return obj.statusPrepare && obj.statusPrepare.some(st => st.value === 'isAlmostExpired');
    },
    showImageContractExprired(obj) {
      return obj.statusPrepare && obj.statusPrepare.some(st => st.value === 'isContractExpired');
    },
    showImageLessThanMeter(obj) {
      return obj.statusPrepare && obj.statusPrepare.some(st => st.value === 'isLessThanMeter');
    },
    setImageRectPositionY(obj, type) {
      // let position = [-10, 20, 50, 80, 110, 130];

      let position = [
        (obj.layout.height * obj.layout.scaleY / 2) - (obj.layout.scaleY * 60),
        (obj.layout.height * obj.layout.scaleY / 2) - (obj.layout.scaleY * 40),
        (obj.layout.height * obj.layout.scaleY / 2) - (obj.layout.scaleY * 20),
        (obj.layout.height * obj.layout.scaleY / 2),
        (obj.layout.height * obj.layout.scaleY / 2) + (obj.layout.scaleY * 15),
        (obj.layout.height * obj.layout.scaleY / 2) + (obj.layout.scaleY * 45),
      ];


      let index = 0;
      if (this.showImageBooking(obj.objectId)) {
        if (type === "booking") return position[index];
        index++;
      }
      if (this.showImageAreaInterest(obj.objectId)) {
        if (type === "areaInterest") return position[index];
        index++;
      }
      if (this.showImageSlip(obj)) {
        if (type === "slip") return position[index];
        index++;
      }
      if (this.showImageDueDate(obj)) {
        if (type === "dueDate") return position[index];
        index++;
      }
      if (this.showImageAlmostExprired(obj)) {
        if (type === "almostExprired") return position[index];
        index++;
      }
      if (this.showImageContractExprired(obj)) {
        if (type === "contractExprired") return position[index];
        index++;
      }
      if (this.showImageLessThanMeter(obj)) {
        if (type === "lessThanMeter") return position[index];
      }
      return 0;
    },
    setImageCirclePositionX(obj, type) {
      let position = [
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2) - (obj.layout.scaleX * 10),
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2),
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2) - (obj.layout.scaleX * 10),
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2) - (obj.layout.scaleX * 30),
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2) - (obj.layout.scaleX * 65),
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2) - (obj.layout.scaleX * 90),
        ((25 / 2) * -1) + (100 * obj.layout.scaleX / 2) - (obj.layout.scaleX * 90),
      ];
      let index = 0;
      let res = 0;
      if (this.showImageBooking(obj.objectId)) {
        if (type === "booking") res = position[index];
        index++;
      }
      if (this.showImageAreaInterest(obj.objectId)) {
        if (type === "areaInterest") res = position[index];
        index++;
      }
      if (this.showImageSlip(obj)) {
        if (type === "slip") res = position[index];
        index++;
      }
      if (this.showImageDueDate(obj)) {
        if (type === "dueDate") res = position[index];
        index++;
      }
      if (this.showImageAlmostExprired(obj)) {
        if (type === "almostExprired") res = position[index];
        index++;
      }
      if (this.showImageContractExprired(obj)) {
        if (type === "contractExprired") res = position[index];
        index++;
      }
      if (this.showImageLessThanMeter(obj)) {
        if (type === "lessThanMeter") res = position[index];
      }
      return res;
    },
    setImageCirclePositionY(obj, type) {
      let position = [
        ((25 / 2) * -1) - (30 * obj.layout.scaleY),
        ((25 / 2) * -1),
        ((25 / 2) * -1) + (30 * obj.layout.scaleY),
        ((25 / 2) * -1) + (50 * obj.layout.scaleY),
        ((25 / 2) * -1) + (50 * obj.layout.scaleY),
        ((25 / 2) * -1) + (30 * obj.layout.scaleY),
        ((25 / 2) * -1) + (30 * obj.layout.scaleY),
        ((25 / 2) * -1) + (30 * obj.layout.scaleY),
      ];
      let index = 0;
      let res = 0;
      if (this.showImageBooking(obj.objectId)) {
        if (type === "booking") res = position[index];
        index++;
      }
      if (this.showImageAreaInterest(obj.objectId)) {
        if (type === "areaInterest") res = position[index];
        index++;
      }
      if (this.showImageSlip(obj)) {
        if (type === "slip") res = position[index];
        index++;
      }
      if (this.showImageDueDate(obj)) {
        if (type === "dueDate") res = position[index];
        index++;
      }
      if (this.showImageAlmostExprired(obj)) {
        if (type === "almostExprired") res = position[index];
        index++;
      }
      if (this.showImageContractExprired(obj)) {
        if (type === "contractExprired") res = position[index];
        index++;
      }
      if (this.showImageLessThanMeter(obj)) {
        if (type === "lessThanMeter") res = position[index];
      }
      return res;
    },
    changeSelectMarket() {
      this.$emit('update:selectMarketArea', this.localSelectMarketArea);
      this.$emit('change');
    },
    resetPlan() {
      for (let areaPlan of this.areaPlans.filter(d => d.type == "area")) {
        let sindex = this.saveList.findIndex(d => d.objectId == areaPlan.objectId);
        if (sindex > -1) {
          this.saveList[sindex] = {
            objectId: areaPlan.objectId,
            type: "area",
            layout: {}
          };
        } else {
          this.saveList.push({
            objectId: areaPlan.objectId,
            type: "area",
            layout: {}
          });
        }
      }
      this.areaPlans = this.areaPlans.filter(d => d.type != "area");
    }
  },
  watch: {
    selectMarketArea(newValue) {
      this.localSelectMarketArea = newValue;
    },
    selectToolBar(selectToolBar) {
      this.onResize();
      this.selectedShapeName = "";
      this.updateTransformer();
    },
    search() {
      this.initSearchAreaPlan()
    },
    selectProduct() {
      this.initSearchAreaPlan()
    },
    selectStatus() {
      this.initSearchAreaPlan()
    },
    searchText(val) {
      this.search = val
    },
    isLoadingSummary(value) {
      if (!value) {
        this.initAreaPlan()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.floorplan-box {
  height: calc(100vh - 310px);

  .area-header,
  .area-list {
    border: 1px solid #999;

    .area-list-card-text {
      padding: 0 5px;

      .area-list-card-text-table {
        padding-top: 5px;
        height: calc(100vh - 410px);
      }

      .area-list-card-text-table::v-deep th,
      .area-list-card-text-table::v-deep td {
        padding: 0;
      }
    }
  }
}

.floorplan-box.select {
  height: calc(100vh - 470px);
}

.floorplan-box.n-select {
  height: calc(100vh - 260px);
}

.floorplan {
  background: white;
  border: 1px solid #999;
  border-radius: 5px;
  position: relative;
  padding: 1px;
  height: calc(100vh - 310px);
}

.floorplan.select {
  height: calc(100vh - 455px);
}

.floorplan.n-select {
  height: calc(100vh - 250px);
}

.zoom {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  right: 10px;
  top: 10px;
  z-index: 5;
  padding: 10px 10px;
  background-color: white;
  border-radius: 7px;
  width: fit-content;
  box-shadow: 0px 12px 30px 0px #0000001F;
  opacity: 0.75;
}

.zoom:hover {
  opacity: 1;
}

.action {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  bottom: 10px;
  z-index: 5;
  padding: 5px;
  background-color: white;
  border-radius: 7px;
  width: fit-content;
  box-shadow: 0px 12px 30px 0px #0000001F;
  opacity: 0.75;
  left: 50%;
  transform: translateX(-50%);
}

.action:hover {
  opacity: 1;
}

.scroll {
  overflow-y: auto;
  height: calc(100vh - 80px);
}

.tooltip-stall {
  width: 295px;
  border-radius: 5px;
  background: #66bb6ae3;
  color: #ffffff;
  font-family: Prompt;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  padding: 10px;
  position: fixed;
  z-index: 5;

  &-header {
    border-bottom: 1px solid #ffffff;

    span {
      font-weight: 700;
    }
  }

  &-body {
    border-bottom: 1px dashed #ffffff;
  }

  &-footer {
    &-sub {
      text-align: center;
      font-weight: 700;
    }
  }

  .tooltip-detail {
    display: flex;
    justify-content: space-between;

    &-result {
      font-weight: 500;
      text-align: right;
    }
  }
}

.text-red {
  color: #D20F14;
  font-weight: bold;
}

.abs-header {
  position: absolute;
  background-color: #fff;
  z-index: 4;
  width: 100%;
  padding: 10px 10px 10px 30px;
  border-bottom: 1px solid #E5E5EF;
  left: 0;
  right: 0;

  .txt-title {
    font-size: 24px;
    font-weight: 700;
  }

  .sub-title {
    font-size: 20px;
    font-weight: 500;
  }
}

.progress-plan-area {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-top-left-radius: 10px;

  .progress-color {
    display: flex;

    .color {
      display: inline-block;
      height: 25px;
      width: 220px;
      background-image: linear-gradient(to right, #C9C9C9, #2F7E33)
    }
  }
}
</style>
